import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { map } from 'rxjs/operators';

// MODELOS
import {
  LoginAccessResponse, LoginInfo, PermResponse
} from './../models/index'
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';


// RUTAS
// COMPONENTES
// SERVICIOS

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  private currentUserEmailSubject: BehaviorSubject<any>;
  public currentUserEmail: Observable<any>;

  constructor(private storageService: StorageService,
      private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.currentUserEmailSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('email')));
    this.currentUserEmail = this.currentUserEmailSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  public deleteCurrentUserValue(): any {
    this.currentUserSubject.next(null);
  }

  public get currentUserEmailValue(): any {
    return this.currentUserEmailSubject.value;
  } 

  login(user: string, email: string) {
    console.log('LOGINNNNNN');
    // se valida que el usuario sea valido
    if(user != null){
      if (user && user.length > 0) {
        this.currentUserSubject.next(user);
        this.storageService.setStorage('currentUser', user);
        this.storageService.setStorage('email', email);
        //this.getToken(user);
      }      
    }
    else {
      let currUser = JSON.parse(this.storageService.getStorage('currentUser'));
      if (!currUser) {
        window.location.href = 'https://appgm.clavisco.com';
      }
    }
  }

 async getToken(userId: string) {
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('UserName', userId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(`${environment.apiUrl}/token`, body.toString(),{ headers })
    // .subscribe((resp: any) => {
    //   this.storageService.setStorage('access_token', resp.access_token);  
    //   })
    }  

  // metodo para desloguearse, elimina la sesion del localstorage y oculta el sidemenu
  logout() {
    this.storageService.deleteStorage('currentUser');
    this.storageService.removPerms();
    this.currentUserSubject.next(null);
    window.location.href = ('https://appgm.clavisco.com/MIS-Principal/Home/Index');
  }

  // metodo para verificar el usuario
  checkUser(UserId: string) {       
    const TOKEN = this.storageService.getToken();   
    const Response: LoginInfo = {      
      UserId: UserId
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `bearer ${TOKEN}`
    });
    return this.http.post<PermResponse>(`${environment.apiUrl}/api/Perms/GetPerms`,
    Response,
      { headers }
    );

  }
}
